<div class="d-flex justify-content-center">
    <div class="card card-rounded card-shadow col-11">
        <div class="card-body" [ngStyle]="{ height: 'auto' }">
            <app-template-priority-loader *ngIf="oppsDropdownIsLoading"></app-template-priority-loader>
            <div class="row" *ngIf="dropdownEntries && dropdownEntries.length > 0">
                <!-- <div class="w-25 col-4"> -->
                <div class="w-50 col-6">
                    <dsy-input-multi
                        id="dropdown"
                        label="Operator - Program - Product"
                        input-status="default"
                        placeholder="Search..."
                        dropdown-label="Open"
                        search-button-label="Search"
                        use-custom-clear-button="true"
                        use-custom-dropdown-button="true"
                        closes-on-selection
                        class="overflow-auto"
                        [isDisabled]="editEnabled"
                        density
                        [handleChange]="onDropdownSearchValueChange"
                        [searchButtonClickCallback]="onDropdownSearchButtonClick"
                    >
                        <div slot="custom-dropdown-button">
                            <dsy-dropdown-button
                                id="dropdown-button"
                                variant="link"
                                size="small"
                                spacing="regular"
                                use-custom-slot
                                [disabled]="editEnabled"
                                [isOpen]="dropdownIsOpen"
                                [entries]="dropdownEntries"
                                [customDsyListConfObject]="customDsyInputMultiConfObject"
                            >
                                <span class="dropdown-label">Open</span>
                                <div slot="custom-dropdown-list-element">
                                    <div class="dropdown-list-container render-below render-right">
                                        <div *ngIf="noResultsFound" class="no-results-found">
                                            <span>No results found</span>
                                        </div>
                                        <div *ngFor="let dropdownEntry of dropdownEntries">
                                            <dsy-list-element *ngIf="dropdownEntry.show"
                                                [ngClass]="[dropdownEntry.isSelected ? 'dropdown-list-item-selected' : '']"
                                                [isSelected]="dropdownEntry.isSelected"
                                                [showRightIcon]="dropdownEntry.showRightIcon"
                                                [rightIconLibrary]="dropdownEntry.rightIconLibrary"
                                                [rightIconName]="dropdownEntry.isSelected ? dropdownEntry.rightIconNameSelected : dropdownEntry.rightIconNameDefault"
                                                [rightIconSize]="dropdownEntry.rightIconSize"
                                                [disabled]="editEnabled"
                                                (click)="onDropdownElementClicked(dropdownEntry)">
                                                <span>{{dropdownEntry.labelContent}}</span>
                                            </dsy-list-element>
                                        </div>
                                    </div>
                                </div>
                            </dsy-dropdown-button>
                        </div>
                    </dsy-input-multi>
                </div>
            </div>
            <hr class="hr m-3" *ngIf="dropdownSelectedEntries?.length > 0" />
            <div class="row" *ngIf="dropdownSelectedEntries?.length > 0">
                <div class="col-4 dropdown-chip-container"
                    *ngFor="let selectedEntry of dropdownSelectedEntries; let i = index"
                    [ngClass]="i < lengthByScreen ? 'visible' : classFilter">
                    <dsy-card card-color="#1F6CF9" height="30px" round-border="true" no-padding="true" *ngIf = "selectedEntry?.product?.id != 'ALL_SEARCH'">
                        <div class="d-flex justify-content-center">
                            <span class="dropdown-chip px-2">{{selectedEntry.labelContent}}</span>
                            <dsy-icon *ngIf="selectedEntry?.product?.id != null && selectedEntry?.product?.id != 'ALL' && selectedEntry.product?.id !== 'ALL_SEARCH'"
                                name="close" library="system" size="16px" class="mt-2 dropdown-chip-close-icon" (click)="onDropdownElementClicked(selectedEntry)"></dsy-icon>
                        </div>                     
                    </dsy-card>
                </div>
                <dsy-button variant="secondary" size="small" shape="square" label="dsy-button" button-style=""
                    class="dropdown-chip-container col-4" type="misc"
                    *ngIf="selectedEntrie?.product?.id !== null"
                    (click)="clearSelectedItems()">Clear Selected Items</dsy-button>
                <div *ngIf="dropdownSelectedEntries.length > lengthByScreen && classFilter === 'visually-hidden'" class="col-sm-6 dropdown-chip-plus-icon">
                    <dsy-card card-color="#F4F8FF" height="30px" round-border="true" no-padding="true" active-border>
                        <div class="d-flex justify-content-center">
                            <dsy-icon name="add" library="system" size="10px" class="mt-2"></dsy-icon>
                            {{dropdownSelectedEntries.length - lengthByScreen}}
                        </div>
                    </dsy-card>
                </div>
            </div>
            <div class="d-flex justify-content-end" *ngIf="dropdownSelectedEntries?.length > lengthByScreen && classFilter === 'visually-hidden'">
                <button (click)="classFilter = 'visible'" class="btn btn-link">
                    <dsy-icon library="system" name="arrow-down" size="16px"></dsy-icon>
                </button>
            </div>
            <div class="d-flex justify-content-end" *ngIf="dropdownSelectedEntries">
                <button *ngIf="dropdownSelectedEntries.length > lengthByScreen && classFilter === 'visible'" (click)="classFilter = 'visually-hidden'"
                    class="btn btn-link">
                    <dsy-icon library="system" name="arrow-up" size="16px"></dsy-icon>
                </button>
            </div>
        </div>
    </div>
</div>